<div class="buttons-container" [yatSpinner]="mode === 'confirmInProgress'" [hideContentWhileSpinning]="true">
  <button yat-button type="button" class="btn btn-secondary-ghost p-0" [disabled]="mode === 'confirmInProgress'" (click)="cancelButtonClick()">
    {{ 'cancel' | commonWording | async }}
  </button>
  <div class="vr"></div>
  <button yat-button type="button" class="btn btn-secondary-ghost" (click)="confirmButtonClick()">
    {{ confirmButtonName }}
  </button>
</div>
